// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text } from '@mantine/core';
import { FC, useContext } from 'react';
import { ProfileContext } from '../../../../Service/Context/ProfileContext';
import { Language } from '../../../../Service/DocumentT';
import DocumentLanguageS from '../../../../Service/DocumentLanguageS';

const PartialInvoiceHeader: FC<{ desktopVersion: boolean; language?: Language | null }> = ({
  desktopVersion,
  language = 'german',
}) => {
  const { profile } = useContext(ProfileContext);
  const t = (id: string) => DocumentLanguageS.translate(language, id);

  return (
    <Group
      spacing="xs"
      p={6}
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[8],
        borderRadius: 6,
        color: 'white',
        fontSize: 12,
      })}
    >
      {desktopVersion ? (
        <>
          <Text ml="md" sx={{ flexGrow: 1 }}>
            {t('document.partial_invoice.less_received')}
          </Text>
          <Text sx={{ width: 100 }}>{t('document.position.net')}</Text>
          {profile && !profile.smallScaleBusiness && (
            <Text sx={{ width: 100 }}>{t('document.partial_invoice.vat')}</Text>
          )}
          <Text sx={{ width: 100 }}>{t('document.partial_invoice.gross')}</Text>
          <div style={{ width: 75 }} />
        </>
      ) : (
        <Text ml="xs">{t('document.templates.partial_invoice')}</Text>
      )}
    </Group>
  );
};

export default PartialInvoiceHeader;
